import { render, staticRenderFns } from "./TgFormTableCell.vue?vue&type=template&id=0a753da3"
import script from "./TgFormTableCell.vue?vue&type=script&lang=js"
export * from "./TgFormTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports